export function questionFactory(question) {
    return {
      answer: question.Answer,
      question: question.Question,
      answerVideo: question.Video_URL,
      answerImg: question.Image_URL
    };
  }
  